module.exports = (__webpack_require__(12))(22);


//////////////////
// WEBPACK FOOTER
// delegated ./plugins/large_image/web_client/collections/AnnotationCollection.js from dll-reference girder_plugin_large_image
// module id = 125
// module chunks = 0